import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../common/FormBase';
import Form from './Form';
import { PREFORM_FIELDS } from './validation/fields';
import { makeInitialState } from '../../../helpers/FormHelper';
import { schema } from './validation/schema';

const PreFormValidateDni = ({ ...props }) => {
  const { mobile, motiveId, issueFormName, info, messageInfo } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        mobile={mobile}
        title=""
        fields={PREFORM_FIELDS}
        pre
        info={info}
        messageInfo={messageInfo}
        data={data}
        formName="PreFormValidDni"
        schema={schema}
        makeInitialState={makeInitialState}
        onState={onState}
        onValid={handleValid}
        form={
          <Form
            state={state}
            onData={handleData}
            valid={valid}
            mobile={mobile}
            motiveId={motiveId}
            issueFormName={issueFormName}
          />
        }
      />
    </React.Fragment>
  );
};

PreFormValidateDni.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  issueFormName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  info: PropTypes.bool,
  messageInfo: PropTypes.string,
};

export default PreFormValidateDni;
